module.exports = __webpack_public_path__ + "static/media/codespotTextImage.b8f5b64e.png";